<template>
  <a-modal
    title="计划追溯信息"
    :width="1200"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    :footer="null"
  >
    <div class="align-center">
      <a-button>追溯需求源</a-button>
      <a-button class="ml10">追溯供应</a-button>
      <a-button class="ml10" @click="handleExport" v-hasPermi="['scp:scpMrpSupplies:exportTraceability']">导出</a-button>
    </div>
    <a-table
      :columns="columns"
      :loading="pageParams.tableLoading"
      :data-source="tableList"
      :pagination="false"
      row-key="id"
      childrenColumnName="internalList"
      :scroll="{ x: 3500, y: 210 }"
    >
      <template v-for="item in columns" :slot="item.dataIndex" slot-scope="{ text }">
        <div :key="item.dataIndex">
          <span v-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
          <span v-else>{{ text }}</span>
        </div>
      </template>
    </a-table>
    <!-- 底部分页按钮 -->
    <Page ref="pageParamter" :pageParams.sync="pageParams" @getList="getList" />
  </a-modal>
</template>

<script>
export default {
  props: {},
  data () {
    return {
      visible: false,
      pageParams: {
        automatic: false,
        pageUrl: '/scp/scpMrpSupplies/queryTraceability',
        tableLoading: false
      },
      queryParams: {
        demandOrSupply: "",
        planName: "",
        planVersion: "",
        supplyId: "",
        demandId: ""
      },
      columns: [
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          align: 'center',
          width: 140,
          ellipsis: true,
          fixed: 'left'
        },
        {
          title: '层级',
          dataIndex: 'itemLevel',
          align: 'center'
        },
        {
          title: '组织',
          dataIndex: 'organizationName',
          align: 'center'
        },
        {
          title: '供应商',
          dataIndex: 'supplierName',
          align: 'center'
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          align: 'center',
          ellipsis: true
        },
        {
          title: '订单类型',
          dataIndex: 'orderTypeName',
          align: 'center'
        },
        {
          title: '分配数量',
          dataIndex: 'allocatedQuantity',
          align: 'center'
        },
        {
          title: '建议到期日',
          dataIndex: 'newDueDate',
          scopedSlots: { customRender: 'newDueDate' },
          align: 'center',
          type: "text"
        },
        {
          title: '建议到货日',
          dataIndex: 'newDockDate',
          scopedSlots: { customRender: 'newDockDate' },
          align: 'center',
          type: "text"
        },
        {
          title: '订单号',
          dataIndex: 'orderNumber',
          align: 'center'
        },
        {
          title: '订单数量',
          dataIndex: 'newOrderQuantity',
          align: 'center'
        },
        {
          title: '来源组织',
          dataIndex: 'sourceOrganizationName',
          align: 'center'
        },
        {
          title: '来源供应商',
          dataIndex: 'sourceSupplierName',
          align: 'center'
        },
        {
          title: '集采类型',
          dataIndex: 'centralizedPurchasingTypeName',
          align: 'center'
        },
        {
          title: '签价单号',
          dataIndex: 'alternateBomDesignator',
          align: 'center'
        },
        {
          title: '最终装配件',
          dataIndex: 'itemCode',
          align: 'center'
        },
        {
          title: '最终需求组织',
          dataIndex: 'finalOrganizationName',
          align: 'center'
        },
        {
          title: '最终需求供应商',
          dataIndex: 'finalSupplierName',
          align: 'center'
        },
        {
          title: '最终需求类型',
          dataIndex: 'orderType',
          align: 'center'
        },
        {
          title: '最终需求数量',
          dataIndex: 'newOrderQuantity',
          align: 'center'
        },
        {
          title: '追溯数量',
          dataIndex: 'endItemUsage',
          align: 'center'
        },
        {
          title: '最终装配件名称',
          dataIndex: 'itemName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '最终装配件规格描述',
          dataIndex: 'specification',
          align: 'center',
          width: 170,
          ellipsis: true
        }
      ],
      tableList: [],
      detail: null
    }
  },
  created () {},
  methods: {
    /** 查询列表 */
    getList (arr) {
      this.tableList = arr
    },
    show (val) {
      this.visible = true
      this.detail = val
      this.queryParams.demandOrSupply = val.demandOrSupply
      this.queryParams.planName = val.planName
      this.queryParams.planVersion = val.planVersion
      this.queryParams.supplyId = val.supplyId
      this.queryParams.demandId = val.demandId
      this.$nextTick(() => {
        this.$refs.pageParamter.getFirstPage(this.queryParams)
      })
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    // 表单重置
    reset () {
      this.tableList = []
    },
    /** 导出按钮操作 */
    handleExport () {
      this.download('scp/scpMrpSupplies/exportTraceability', {
        ...this.queryParams
      }, `物料来源_计划追溯信息_${new Date().getTime()}.xlsx`)
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
</style>
